import { render, staticRenderFns } from "./ButtonRemove.html?vue&type=template&id=289b3568&"
import script from "./ButtonHistoryRemove.vue?vue&type=script&lang=ts&"
export * from "./ButtonHistoryRemove.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports